export const PRODUCT_CATALOG_VERSION = 2;

export const PRODUCTS = [
  { id: 'bud', name: 'Bud', baseMin: 5, baseMax: 10, unitSingular: 'gram', unitPlural: 'grams', unitShort: 'g', capacityWeight: 1,
    options: [{ label: '1/8 oz', weight: 3.5 }, { label: '1/4 oz', weight: 7 }, { label: '1 oz', weight: 28 }, { label: 'QP', weight: 112 }, { label: 'HP', weight: 224 }, { label: 'Pound', weight: 448 }] },
  { id: 'dabs', name: 'Dabs', baseMin: 20, baseMax: 40, unitSingular: 'gram', unitPlural: 'grams', unitShort: 'g', capacityWeight: 1,
    options: [{ label: '1 Gram', weight: 1 }, { label: '1/8 oz', weight: 3.5 }, { label: '1/4 oz', weight: 7 }, { label: '1 oz', weight: 28 }] },
  { id: 'shrooms', name: 'Shrooms', baseMin: 8, baseMax: 15, unitSingular: 'gram', unitPlural: 'grams', unitShort: 'g', capacityWeight: 1,
    options: [{ label: '1/8 oz', weight: 3.5 }, { label: '1/4 oz', weight: 7 }, { label: '1 oz', weight: 28 }, { label: 'QP', weight: 112 }] },
  { id: 'meth', name: 'Meth', baseMin: 60, baseMax: 100, unitSingular: 'gram', unitPlural: 'grams', unitShort: 'g', capacityWeight: 1,
    options: [{ label: '1 Gram', weight: 1 }, { label: '8-Ball', weight: 3.5 }, { label: '1/4 oz', weight: 7 }, { label: '1 oz', weight: 28 }] },
  { id: 'heroin', name: 'Heroin', baseMin: 80, baseMax: 120, unitSingular: 'gram', unitPlural: 'grams', unitShort: 'g', capacityWeight: 1,
    options: [{ label: '1 Gram', weight: 1 }, { label: '8-Ball', weight: 3.5 }, { label: '1/4 oz', weight: 7 }, { label: '1 oz', weight: 28 }] },
  { id: 'acid', name: 'Acid', baseMin: 3, baseMax: 7, unitSingular: 'hit', unitPlural: 'hits', unitShort: 'hit', capacityWeight: 0.02,
    options: [{ label: '1 Hit', weight: 1 }, { label: '5 Hits', weight: 5 }, { label: '10 Hits', weight: 10 }, { label: '25 Hits', weight: 25 }, { label: '50 Hits', weight: 50 }, { label: '100 Hits', weight: 100 }],
    volatility: { crashChance: .15, crashMin: .50, crashMax: .75, spikeChance: .15, spikeMin: 1.50, spikeMax: 2.20 }, marketShiftWeight: 3,
    riskTiers: [{ minimum: 25, police: 1.10, mugging: 1.10 }, { minimum: 100, police: 1.25, mugging: 1.20 }] },
  { id: 'coke', name: 'Coke', baseMin: 70, baseMax: 140, unitSingular: 'gram', unitPlural: 'grams', unitShort: 'g', capacityWeight: 1, priceFloor: 45, priceCap: 225,
    options: [{ label: '1 Gram', weight: 1 }, { label: '5 Grams', weight: 5 }, { label: '10 Grams', weight: 10 }, { label: '20 Grams', weight: 20 }],
    volatility: { crashChance: .08, crashMin: .55, crashMax: .75, spikeChance: .08, spikeMin: 1.50, spikeMax: 1.90 }, marketShiftWeight: 1.5,
    riskTiers: [{ minimum: 5, police: 1.10, mugging: 1.10 }, { minimum: 20, police: 1.25, mugging: 1.25 }] },
];

export const productById = (productId) => PRODUCTS.find((product) => product.id === productId);
export const productUnit = (productId, quantity = 2) => {
  const product = productById(productId);
  return Number(quantity) === 1 ? (product?.unitSingular || 'gram') : (product?.unitPlural || 'grams');
};
export const productUnitShort = (productId) => productById(productId)?.unitShort || 'g';
export const formatProductQuantity = (productId, quantity) => `${Number(quantity || 0).toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1')} ${productUnit(productId, quantity)}`;
export const productCapacityAmount = (productId, quantity) => Number(quantity || 0) * Number(productById(productId)?.capacityWeight ?? 1);
export const productQuantityForCapacity = (productId, capacity) => Number(capacity || 0) / Math.max(.000001, Number(productById(productId)?.capacityWeight ?? 1));
export const inventoryCapacityUsed = (inventory = {}) => PRODUCTS.reduce((total, product) => total + productCapacityAmount(product.id, inventory[product.id] || 0), 0);

export const LOCATIONS = [
  { id: 'mlk_park', neighborhoodId: 'redding', name: 'MLK Park (Redding)', description: 'Poor area, dangerous, mostly homeless, low police.', dangerLevel: .20, policeLevel: .05, availableProducts: PRODUCTS.map((p) => p.id), priceMultiplier: .8,
    buyPriceRanges: { acid: [5,9], coke: [55,110] }, sellPriceRanges: { acid: [5,9], coke: [55,110] }, dailyStockRanges: { acid: [20,80], coke: [8,25] }, dailyDemandRanges: { acid: [20,80], coke: [8,25] } },
  { id: 'jims_place', neighborhoodId: 'mt_gate', name: "Old Man Jim's Trailer", description: 'A filthy, sagging trailer at the edge of the Trailer Park, with smoke-stained siding, taped windows, and junk piled around the steps.', dangerLevel: .02, policeLevel: .02, availableProducts: ['bud','dabs','shrooms','acid','coke'], priceMultiplier: 1.1,
    buyPriceRanges: { acid: [3,7], coke: [80,140] }, sellPriceRanges: { acid: [3,7], coke: [80,140] }, dailyStockRanges: { acid: [20,100], coke: [3,12] }, dailyDemandRanges: { acid: [20,80], coke: [3,10] } },
  { id: 'jimmys_house', neighborhoodId: 'redding', name: "Jimmy's House (Redding)", description: 'Computer nerd hacker. Safe, but selective.', dangerLevel: .02, policeLevel: .02, availableProducts: ['bud','dabs','shrooms','acid','coke'], priceMultiplier: 1.1,
    buyPriceRanges: { acid: [5,9], coke: [60,115] }, sellPriceRanges: { acid: [5,9], coke: [60,115] }, dailyStockRanges: { acid: [20,80], coke: [8,25] }, dailyDemandRanges: { acid: [20,80], coke: [8,25] } },
  { id: 'trailer_park', neighborhoodId: 'mt_gate', name: 'Trailer Park (MT Gate)', description: 'Shady tweakers, police often here for domestic disputes.', dangerLevel: .15, policeLevel: .08, availableProducts: PRODUCTS.map((p) => p.id), priceMultiplier: 1,
    buyPriceRanges: { acid: [4,12], coke: [100,180] }, sellPriceRanges: { acid: [4,12], coke: [110,180] }, dailyStockRanges: { acid: [10,60], coke: [2,10] }, dailyDemandRanges: { acid: [50,150], coke: [8,25] },
    productVolatility: { acid: { spikeChance: .20, spikeMin: 1.5, spikeMax: 1.5 }, coke: { spikeChance: .12, spikeMin: 1.35, spikeMax: 1.60 } } },
  { id: 'arcata', neighborhoodId: 'arcata', name: 'Arcata (California)', description: 'Hippy types. Best buds and shrooms around. Safe if you watch your back.', dangerLevel: .10, policeLevel: .05, availableProducts: PRODUCTS.map((p) => p.id), priceMultiplier: 1.2, specialties: ['bud','shrooms'],
    buyPriceRanges: { acid: [1,4], coke: [120,180] }, sellPriceRanges: { acid: [1,3], coke: [110,175] }, dailyStockRanges: { acid: [100,300], coke: [5,15] }, dailyDemandRanges: { acid: [20,80], coke: [10,25] } },
  { id: 'valley_west_boulevard', neighborhoodId: 'arcata', name: 'Valley West Boulevard', description: 'A grim strip of motels, parking lots, camps, stolen bikes, tweakers, and desperate street commerce. Weed and Acid are everywhere; hard-drug buyers pay well, and cash attracts attention.', dangerLevel: .15, policeLevel: .025,
    availableProducts: ['bud','acid'], buyProducts: ['bud','acid'], sellProducts: ['bud','meth','heroin','acid'], priceMultiplier: 1, buyPriceMultipliers: { bud: .78 }, sellPriceMultipliers: { bud: .55, meth: 1.35, heroin: 1.45 }, buyPriceRanges: { acid: [2,5] }, sellPriceRanges: { acid: [1,3] }, dailyStock: { bud: 224 }, dailyDemand: { bud: 56, meth: 28, heroin: 14 }, dailyStockRanges: { acid: [50,150] }, dailyDemandRanges: { acid: [5,25] }, marketShiftEnabled: false, localIncidentCooldownDays: 1 },
  { id: 'larrens_farm', name: "Larren's Pot Farm (SW Missouri)", description: 'Cops are on the payroll. Very safe. Fly in by private plane.', dangerLevel: 0, policeLevel: 0, availableProducts: ['bud','dabs'], priceMultiplier: .5, unlockRequirement: 5000 },
  { id: 'cavemans_house', name: "Caveman's House (Lakehead)", description: 'You got lost. Pretty safe, minus rattlesnakes and... other distractions.', dangerLevel: 0, policeLevel: 0, availableProducts: PRODUCTS.map((p) => p.id), priceMultiplier: .9, buyPriceRanges: { acid: [3,7], coke: [70,140] }, sellPriceRanges: { acid: [3,7], coke: [70,140] }, isHidden: true, shortsProducts: true },
  { id: 'corner_store', neighborhoodId: 'mt_gate', name: 'The Corner Store', description: 'Cigs, beer, gas, scratchers, gossip, and bad decisions all under one leaky roof.', dangerLevel: 0, policeLevel: 0, availableProducts: [], priceMultiplier: 1, isSceneLocation: true, isLocalStop: true, localFrom: 'trailer_park', returnLocation: 'trailer_park' },
  { id: 'kens_house', neighborhoodId: 'mt_gate', name: "Ken the Tweaker's House", description: 'A run-down house in the boonies surrounded by broken cars, scrap piles, and highly questionable commerce.', dangerLevel: .12, policeLevel: .04, availableProducts: [], priceMultiplier: 1, isSceneLocation: true, isKenHouse: true },
  { id: 'mikeys_place', neighborhoodId: 'mt_gate', name: "Mikey's Place", description: 'A filthy Mt. Gate hangout where Mikey routinely pays too much for weed and meth. Keep an eye on anything you parked outside.', dangerLevel: .08, policeLevel: .02, availableProducts: [], priceMultiplier: 1, isSceneLocation: true, isSpecialCharacterLocation: true, specialCharacterId: 'mikey', introducedEventPack: 'classic-1.9' },
  { id: 'mt_gate_playground', neighborhoodId: 'mt_gate', name: 'The Playground', description: 'The little school playground after hours. Mt. Gate delinquents unload cheap, questionable bud and meth here when they actually have some.', dangerLevel: .165, policeLevel: .092, availableProducts: ['bud','meth'], priceMultiplier: 1, introducedEventPack: 'classic-1.11',
    buyPriceMultiplierRanges: { bud: [.70,.90], meth: [.75,.95] }, sellPriceMultiplierRanges: { bud: [.55,.70], meth: [.55,.70] }, dailyStockRanges: { bud: [7,42], meth: [1,6] }, dailyStockoutChances: { bud: .15, meth: .25 }, dailyDemandRanges: { bud: [7,28], meth: [1,5] }, marketShiftEnabled: false },
  { id: 'the_creek', neighborhoodId: 'mt_gate', name: 'The Creek', description: "Mt. Gate's local swimming hole, where the cool people swim, drink beer, foul up the water, and trade ordinary Bud and Meth.", dangerLevel: .10, policeLevel: .055, availableProducts: ['bud','meth'], priceMultiplier: 1, introducedEventPack: 'classic-1.12',
    buyPriceMultiplierRanges: { bud: [.85,1.00], meth: [.90,1.05] }, sellPriceMultiplierRanges: { bud: [.75,.95], meth: [.80,.98] }, dailyStockRanges: { bud: [14,70], meth: [2,10] }, dailyDemandRanges: { bud: [14,56], meth: [2,8] }, marketShiftEnabled: false },
  { id: 'robs_trailer', neighborhoodId: 'mt_gate', name: "Rob's Trailer", description: "Rob the Hippie's worn-out trailer: peace signs, old music posters, stale smoke, a giant bong, and one profoundly unmotivated cat.", dangerLevel: .015, policeLevel: .01, availableProducts: [], priceMultiplier: 1, isSceneLocation: true, isRobLocation: true },
  { id: 'home', name: 'Home', description: 'Your safehouse. Bank your cash and stash your product.', dangerLevel: 0, policeLevel: .01, availableProducts: [], priceMultiplier: 1, isHome: true },
  { id: 'pawn_shop', name: 'Pawn Shop (Redding)', description: 'Sell your fenced and traded goods here. No drugs allowed.', dangerLevel: .1, policeLevel: .05, availableProducts: [], priceMultiplier: 1, isPawnShop: true },
];

export const NEIGHBORHOODS = [
  {
    id: 'mt_gate',
    name: 'Mt. Gate',
    description: 'Trailer roads, junk yards, and several addresses nobody writes down correctly.',
    entryLocationId: 'trailer_park',
    locationIds: ['trailer_park', 'jims_place', 'corner_store', 'kens_house', 'mikeys_place', 'mt_gate_playground', 'the_creek', 'robs_trailer'],
  },
  {
    id: 'redding',
    name: 'Redding',
    description: 'Parks, back streets, and enough heat to make every bad decision sweat.',
    entryLocationId: 'mlk_park',
    locationIds: ['mlk_park', 'jimmys_house'],
  },
  {
    id: 'arcata',
    name: 'Arcata',
    description: 'A separate market neighborhood with good bud, shrooms, and plenty of opinions.',
    entryLocationId: 'arcata',
    locationIds: ['arcata', 'valley_west_boulevard'],
  },
];

export const STANDALONE_LOCATION_IDS = ['home', 'pawn_shop', 'larrens_farm'];

export const locationById = (locationId) => LOCATIONS.find((location) => location.id === locationId);
export const neighborhoodById = (neighborhoodId) => NEIGHBORHOODS.find((neighborhood) => neighborhood.id === neighborhoodId);
export const neighborhoodForLocation = (locationId) => {
  const location = locationById(locationId);
  return location?.neighborhoodId ? neighborhoodById(location.neighborhoodId) : null;
};

export const travelClassFor = (currentLocationId, destinationLocationId) => {
  if (destinationLocationId === 'corner_store' && currentLocationId === 'trailer_park') return 'special_local';
  const current = neighborhoodForLocation(currentLocationId);
  const destination = neighborhoodForLocation(destinationLocationId);
  return current && destination && current.id === destination.id ? 'local' : 'cross_neighborhood';
};

export const TRAVEL_GEAR = {
  skateboard: { name: 'Beat-Up Skateboard', debtGrowthFactor: 0.75, encounterMultiplier: 1.50, muggingMultiplier: 1.75 },
  bicycle: { name: 'Used Bicycle', debtGrowthFactor: 0.55, encounterMultiplier: 1.25, muggingMultiplier: 1.40 },
};

export const BARTER_PRICES = {
  stereo: 500,
  computer: 1200,
  gun: 800,
  stolen_stereo: 100,
  stolen_computer: 250,
  stolen_gun: 150,
  car_stereo_bundle: 180,
  shopping_cart_electronics: 140,
  broken_electronics: 25,
  mystery_junk: 60,
  hot_catalytic_converter: 125,
  contractor_tool_bag: 90
};

export const INITIAL_STATE = {
  day: 1,
  maxDays: 30,
  cash: 2000,
  debt: 5000,
  health: 100,
  capacity: 2000,
  productCatalogVersion: PRODUCT_CATALOG_VERSION,
  inventory: Object.fromEntries(PRODUCTS.map((product) => [product.id, 0])),
  // New V2/V3 State
  bankCash: 0,
  stash: Object.fromEntries(PRODUCTS.map((product) => [product.id, 0])),
  barterInventory: {
    stereo: 0,
    computer: 0,
    gun: 0,
    stolen_stereo: 0,
    stolen_computer: 0,
    stolen_gun: 0,
    car_stereo_bundle: 0,
    shopping_cart_electronics: 0,
    broken_electronics: 0,
    mystery_junk: 0,
    hot_catalytic_converter: 0,
    contractor_tool_bag: 0
  },
  streetInventory: {
    smokes: 0,
    beer: 0
  },
  streetPrices: { smokes: null },
  cornerStore: {
    day: 1,
    smokesBought: 0,
    beerBought: 0,
    scratchersBought: 0,
    lastScratcherResults: [],
    lastScratcherReveals: [],
    lastScratcherCost: 0,
    lastScratcherPayout: 0,
    scratcherHistory: [],
    stats: {}
  },
  travelGear: {
    skateboard: { owned: false, acquiredDay: 0, purchasePrice: 0 },
    bicycle: { owned: false, acquiredDay: 0, purchasePrice: 0 }
  },
  pawnTravelStock: {
    day: 0,
    skateboard: { available: false, price: 350 },
    bicycle: { available: false, price: 800 }
  },
  kenHouse: {
    day: 0, rolled: false, methStock: 0, weedDemand: 0, methPrice: 0, weedOffer: 0,
    repRequirement: 70, repDiscount: 0, repValueBonus: 0, junkFactor: 0.7,
    wifeFlavor: "Somebody inside is yelling about a missing bottle opener.", stats: {}
  },
  travelServices: {
    chaz: {
      active: false, ridesRemaining: 0, ridesGrantedThisDeal: 0, startedDay: 0,
      policeRiskMultiplier: 1.75, waiveTravelDebt: true, label: 'Chaz and the T-Bird',
      stats: { dealsAccepted: 0, ridesGranted: 0, ridesUsed: 0, policeStops: 0, weedPaidGrams: 0 }
    }
  },
  lastTravel: { mode: 'normal', travelClass: 'spawn', dayAdvanced: false, policeRiskMultiplier: 1, encounterMultiplier: 1, muggingMultiplier: 1, debtGrowthFactor: 0, serviceEnded: false },
  bulletinBoard: {
    version: 2,
    title: 'The Corner Store Bulletin Board',
    subtitle: 'System notices now. Jobs, rumors, graffiti, and moderated player requests later.',
    categories: ['system', 'update', 'maintenance', 'event', 'warning', 'rumor', 'jobs', 'graffiti', 'requests'],
    posts: []
  },
  homeRaidChance: 0.01,
  streetRep: 50, // 0 to 100
  activeEvent: null,
  eventQueue: [],
  eventRuntime: { counts: {}, last_day: {}, flags: [] },
  eventPack: 'classic-1.7',
  difficulty: 'low',
  
  worldMap: { neighborhoods: NEIGHBORHOODS, currentNeighborhoodId: null, standaloneLocationIds: STANDALONE_LOCATION_IDS },
  currentLocationId: 'home',
  marketPrices: {},
  marketBuyPrices: {},
  marketSellPrices: {},
  marketStock: {},
  marketDemand: {},
  marketProfile: {},
  marketNotebook: {},
  marketPriceLabels: { buy: {}, sell: {} },
  dailyLocationMarkets: { day: 1, productCatalogVersion: PRODUCT_CATALOG_VERSION, markets: {}, sellMarkets: {}, stocks: {}, demands: {}, streetPrices: {}, events: {} },
  messages: ["Welcome to The Dope Man. You have 30 days to pay off your debt. Watch your back."]
};
